import request from '@/utils/request'

export function getUser() {
    return request({
      url: '/user/info',
      method: 'get'
    })
}

export function mymylogin(form_data) {
    return request({
      url: '/user/login',
      method: 'post',
      data: form_data
    })
}

export function getcoinbalance(exchangeName, userId) {
  return request({
    url: '/getbalance?exchangeName=' + exchangeName + '&'+'user_Id='+userId,
    method: 'get'
  })
}

export function getfinancialrecords(exchangeName, userId) {
  return request({
    url: '/getfinancialrecords?exchangeName=' + exchangeName + '&'+'user_Id='+userId,
    method: 'get'
  })
}

export function getAssetValue(exchangeName, userId, symbol) {
  return request({
    url: '/getassetsvalue?exchangeName=' + exchangeName + '&'+'user_Id='+userId + '&'+'symbol='+symbol,
    method: 'get'
  })
}

// export function getEquityList() {
//   return request({
//     url: '/account/list',
//     method: 'get'
//   })
// }

export function getEquityList() {
  return request({
    url: '/account/list',
    method: 'get'
  })
}

export function getPositionList(alias) {
  return request({
    url: '/account/position/getcoinposition?alias='+alias,
    method: 'get'
  })
}

export function getSpotPositionList() {
  return request({
    url: '/account/position/getspotposition',
    method: 'get'
  })
}

export function getTradesData(search_text, limit, offset) {
  return request({
    url: '/data_management/trade/page?search_text=' + search_text + '&limit='+ limit + '&offset=' + offset,
    method: 'get'
  })
}

export function getOrdersData(search_text, limit, offset) {
  return request({
    url: '/data_management/order/page?search_text=' + search_text + '&limit='+ limit + '&offset=' + offset,
    method: 'get'
  })
}

export function getTradeFeeData(alias, limit, offset) {
  return request({
    url: '/data_management/trade_fee/page?alias=' + alias + '&limit='+ limit + '&offset=' + offset,
    method: 'get'
  })
}

export function getFundingData(symbol, exchange) {
  return request({
    url: '/data_management/funding?symbol='+symbol + '&exchange=' + exchange,
    method: 'get'
  })
}

export function getFundingRankData(exchange) {
  return request({
    url: '/data_management/funding/rank?exchange='+exchange,
    method: 'get'
  })
}

export function getPositionOverview() {
  return request({
    url: '/data_management/position/overview',
    method: 'get'
  })
}


export function getEquityAll(alias) {
  return request({
    url: '/account/equity/all?alias='+alias,
    method: 'get'
  })
}

export function getMargin(alias) {
  return request({
    url: '/account/margin/latest?alias='+alias,
    method: 'get'
  })
}

export function getTotalMargin(alias) {
  return request({
    url: '/account/margin/total?alias='+alias,
    method: 'get'
  })
}

export function getStrategyRet(alias) {
  return request({
    url: '/account/equity_wmy?alias='+alias,
    method: 'get'
  })
}

export function getStrategyFunding(alias) {
  return request({
    url: '/account/fundingratio?alias='+alias,
    method: 'get'
  })
}

export function transferCoin(out_exchange, in_exchange, symbol, amount, passwd, server_index) {
  return request({
    url: 'strategy/transfer?out_exchange=' + out_exchange +'&in_exchange='+in_exchange+'&symbol='+symbol+'&amount='+amount+'&passwd='+passwd+'&server_index='+server_index,
    method: 'post'
  })
}

export function binanceLoan(data) {
  return request({
    url: '/account/loan',
    method: 'post',
    data: data
  })
}

export function getCrossPosition(alias) {
  return request({
    url: '/account/position/cross_exchange?alias='+alias,
    method: 'get'
  })
}

export function getCrossBalance(alias) {
  return request({
    url: '/account/balance/cross_exchange?alias='+alias,
    method: 'get'
  })
}

export function getCrossFunding(alias) {
  return request({
    url: '/account/funding_rate/cross?alias='+alias,
    method: 'get'
  })
}

export function getCrossEquity(alias) {
  return request({
    url: '/account/equity/cross?alias='+alias,
    method: 'get'
  })
}


export function getScheduler() {
  return request({
    url: '/monitor/scheduler_list',
    method: 'get'
  })
}

export function getRiskScheduler() {
  return request({
    url: '/monitor/risk_list',
    method: 'get'
  })
}

export function updateScheduler(data) {
  return request({
    url: '/monitor/risk_update',
    method: 'post',
    data: data
  })
}


export function getSummaryEquity() {
  return request({
    url: '/account/equity_summary',
    method: 'get'
  })
}

export function getSummaryEquity1() {
  return request({
    url: '/account/equity_sum',
    method: 'get'
  })
}

export function getSummaryAccount(username) {
  return request({
    url: '/account/equity_sum_user?username=' + username,
    method: 'get'
  })
}


export function getShowEquity(alias) {
  return request({
    url: '/account/equity_weekly?alias='+alias,
    method: 'get'
  })
}


export function getTradeBasis(search_text, limit, offset) {
  return request({
    url: '/strategy/trade_basis/page?search_text=' + search_text + '&limit='+ limit + '&offset=' + offset,
    method: 'get'
  })
}

export function getOperateList() {
  return request({
    url: '/operate/list',
    method: 'get'
  })
}

export function getOperateLog(last_id) {
  return request({
    url: '/operate/log?last_id=' + last_id,
    method: 'get'
  })
}


export function CreateOperate(data) {
  return request({
    url: '/operate/create',
    method: 'post',
    data: data
  })
}


export function getStrategyList() {
  return request({
    url: '/strategy/strategy_list',
    method: 'get'
  })
}


export function getStrategyListPair(alias, sort_by, direction) {
  return request({
    url: '/strategy/strategy_list/pairtrading?alias=' + alias + "&sort_by=" + sort_by + "&direction=" + direction,
    method: 'get'
  })
}

export function updateStrategy(data) {
  return request({
    url: '/strategy/strategy_update',
    method: 'post',
    data: data
  })
}

export function deleteStrategy(data) {
  return request({
    url: '/strategy/strategy_delete',
    method: 'post',
    data: data
  })
}

export function startStrategy1(data) {
  return request({
    url: '/strategy/strategy_start',
    method: 'post',
    data: data
  })
}


export function createStrategy(data) {
  return request({
    url: '/strategy/strategy_create',
    method: 'post',
    data: data
  })
}

export function stopStrategy1(data) {
  return request({
    url: '/strategy/strategy_stop',
    method: 'post',
    data: data
  })
}

export function getAliasList() {
  return request({
    url: '/user/alias/list',
    method: 'get'
  })
}

export function getAliasStrategy(alias, strategy_name) {
  return request({
    url: '/strategy/history_setting?alias='+ alias + '&strategy_name=' + strategy_name,
    method: 'get'
  })
}


export function getStrategyClass() {
  return request({
    url: '/strategy/class/list',
    method: 'get'
  })
}


export function getEquityOverview() {
  return request({
    url: '/account/overview/equity',
    method: 'get'
  })
}


export function getProfitOverview() {
  return request({
    url: '/account/overview/profit',
    method: 'get'
  })
}

export function getLeverageOverview() {
  return request({
    url: '/account/overview/leverage',
    method: 'get'
  })
}

export function getInterestOverview(days) {
  return request({
    url: '/account/overview/interest?days=' + days,
    method: 'get'
  })
}

export function getInterestRateYearly() {
  return request({
    url: '/account/overview/interest_rate',
    method: 'get'
  })
}

export function getFundingRateYearly() {
  return request({
    url: '/account/overview/funding_rate',
    method: 'get'
  })
}

export function getInterestList() {
  return request({
    url: '/account/overview/interest/list',
    method: 'get'
  })
}

export function getNetPositiontList() {
  return request({
    url: '/account/overview/net_position',
    method: 'get'
  })
}
export function getBasisList(period, interval, coin) {
  return request({
    url: '/account/overview/basis_list?period=' + period + "&interval=" + interval + "&coin="  +coin,
    method: 'get'
  })
}
export function getBasisQuarter() {
  return request({
    url: '/account/overview/basis_quarter',
    method: 'get'
  })
}

export function getExchangeList(alias) {
  return request({
    url: '/account/exchange/list?alias=' + alias,
    method: 'get'
  })
}

export function getExchangeBalance(alias, exchange) {
  return request({
    url: '/account/exchange/balance?alias=' + alias + "&exchange=" + exchange,
    method: 'get'
  })
}

export function getExchangeTransferList(alias, exchange) {
  return request({
    url: '/account/exchange/transfer/list?alias=' + alias + "&exchange=" + exchange,
    method: 'get'

    
  })
}

export function transfer(data) {
  return request({
    url: '/account/transfer',
    method: 'post',
    data: data
  })
}


export function getProfitData(alias, limit, offset) {
  return request({
    url: '/data_management/profit/page?alias=' + alias + '&limit='+ limit + '&offset=' + offset,
    method: 'get'
  })
}

export function getMonthProfitData(alias, limit, offset) {
  return request({
    url: '/data_management/profit_monthly/page?alias=' + alias + '&limit='+ limit + '&offset=' + offset,
    method: 'get'
  })
}

export function getChargeData(alias="") {
  return request({
    url: '/data_management/charge/list?alias=' + alias,
    method: 'get'
  })
}


export function getAliasBasisData(alias, limit, offset) {
  return request({
    url: '/strategy/alias_basis/page?alias=' + alias + '&limit='+ limit + '&offset=' + offset,
    method: 'get'
  })
}


export function getScoreList() {
  return request({
    url: '/monitor/score',
    method: 'get'
  })
}

export function getScoreList2() {
  return request({
    url: '/monitor/score2',
    method: 'get'
  })
}

export function getYzb01() {
  return request({
    url: '/monitor/yzb01',
    method: 'get'
  })
}

export function getOceanScore() {
  return request({
    url: '/monitor/ocean_score',
    method: 'get'
  })
}